import { AnimatePresence, motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { FaAngleDown } from "react-icons/fa";
import { NavLink, useLocation } from "react-router-dom";

import { MdOutlineAddCircle } from "react-icons/md";

import { MdAddCircleOutline } from "react-icons/md";
import { HiMinusCircle } from "react-icons/hi";
import { FiMinusCircle } from "react-icons/fi";


const menuAnimation = {
  hidden: {
    opacity: 0,
    height: 0,
    padding: 0,
    transition: { duration: 0.3, when: "afterChildren" },
  },
  show: {
    opacity: 1,
    height: "auto",
    transition: {
      duration: 0.3,
      when: "beforeChildren",
    },
  },
};
const menuItemAnimation = {
  hidden: (i) => ({
    padding: 0,
    x: "-100%",
    transition: {
      duration: (i + 1) * 0.1,
    },
  }),
  show: (i) => ({
    x: 0,
    transition: {
      duration: (i + 1) * 0.1,
    },
  }),
};

const SidebarMenu = ({ route, showAnimation, isOpen, setIsOpen }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsOpen(true);
  };

  // Sub-routes that share a pathname (e.g. /Skills?tab=live and /Skills?tab=agents)
  // can't be distinguished by NavLink's built-in active matching, which ignores
  // query strings. Match pathname + any query params declared on the sub-route.
  const isSubRouteActive = (subPath) => {
    const [pathname, search = ""] = String(subPath).split("?");
    if (pathname !== location.pathname) return false;
    if (!search) return true;
    const want = new URLSearchParams(search);
    const have = new URLSearchParams(location.search);
    for (const [k, v] of want.entries()) {
      if (have.get(k) !== v) return false;
    }
    return true;
  };

  // Auto-expand the submenu when the user lands on (or deep-links to) a URL
  // that matches one of its sub-routes.
  const anySubActive = (route.subRoutes || []).some((sr) => isSubRouteActive(sr.path));
  useEffect(() => {
    if (anySubActive) setIsMenuOpen(true);
  }, [anySubActive]);

  useEffect(() => {
    if (!isOpen) {
      setIsMenuOpen(false);
    }
  }, [isOpen]);
  return (
    <>
      <div className="menu " onClick={toggleMenu}>
        <div className="menu_item ">
          <div className="icon">{route.icon}</div>
          <AnimatePresence>
            {isOpen && (
              <motion.div
                variants={showAnimation}
                initial="hidden"
                animate="show"
                exit="hidden"
                className="link_text"
              >
                {route.name}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        {isOpen && (
          <motion.div
            // animate={
            //   isMenuOpen
            //     ? {
            //         rotate: -90,
                    
            //       }
            //     : { rotate: 0 }
            // }
          >
            {
              isMenuOpen
                ? <FiMinusCircle style={{cursor:'pointer'}} size="20" color="currentColor" />
                : <MdAddCircleOutline style={{cursor:'pointer'}} size="20" color="currentColor"  />
            }
            
          </motion.div>
        )}
      </div>{" "}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            variants={menuAnimation}
            initial="hidden"
            animate="show"
            exit="hidden"
            className="menu_container "
          >
            {route.subRoutes.map((subRoute, i) => (
              <motion.div variants={menuItemAnimation} key={i} custom={i}>
                {/* Function-form className suppresses react-router v6's
                    automatic `active` class — needed because every sub-route
                    here shares the same pathname (only the ?tab= differs)
                    and would otherwise all light up at once. */}
                <NavLink
                  to={subRoute.path}
                  className={() => isSubRouteActive(subRoute.path) ? "link active" : "link"}
                >
                  <div className="icon">{subRoute.icon}</div>
                  <motion.div className="link_text">{subRoute.name}</motion.div>
                </NavLink>


              </motion.div>
            ))}
          </motion.div>
        )}{" "}
      </AnimatePresence>
    </>
  );
};

export default SidebarMenu;
